// @vue/component
export default {
  name: 'ConnectionsEffectIcon',

  props: {
    color: {
      type: String,
      default: null,
    },
    icon: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: 'Efekt nieznany',
    },
    description: {
      type: String,
      default: 'Brak informacji o efekcie połączenia',
    },
  },

  computed: {
    iconStyle() {
      return {
        backgroundColor: this.color,
      };
    },
  },
};
